export interface TopVendorsDataResponse {
  total_count: number;
  vendors: TopVendorData[];
}

export interface TopVendorData {
  vendor_name: string;
  total_spend_usd: number;
  market: string;
  region: string;
  vendor_country: string;
}

export enum FlagType {
  OPERATIONAL = 'operational',
  FINANCIAL = 'financial',
}
